import { ModelCache } from '@mng/model';
import { Antragdata, Person } from '../antrag.model.types';
import { IAntragFragen, IZusatzFlagsFuerSonderBehandlung } from './logic/antrag-fragen';
import {
  getFragenBlockDefsForGesundheitsfragenGruppePerson,
  getFragenBlockDefsForPerson,
  getFragenDefsForLvTarif,
  getZusatzFragenSonderbehandlungForPerson
} from './logic/frage-block-auswahl.logic';
import { bufferedLogger } from '@mng/logging';

export class AntragContext extends ModelCache {
  getFragen(antrag: Antragdata, person: Person): IAntragFragen {
    const fragenKey: string = this.fragenKey(person);
    let fragen: IAntragFragen = this.getItem(fragenKey);
    if (!fragen) {
      fragen = getFragenBlockDefsForPerson(antrag, person);
      this.putItem(fragenKey, fragen);
    }
    return fragen;
  }

  getGesundheitsFragenGruppen(person: Person, loggingStreamId?: string): Set<string> {
    const gesundheitsFragenGruppenKey: string = this.gesundheitsFragenGruppenKey(person);
    let gesundheitsFragenGruppen: Set<string> = this.getItem(gesundheitsFragenGruppenKey);
    if (!gesundheitsFragenGruppen) {
      gesundheitsFragenGruppen = getFragenBlockDefsForGesundheitsfragenGruppePerson(person, loggingStreamId);
      this.putItem(gesundheitsFragenGruppenKey, gesundheitsFragenGruppen);
    }

    bufferedLogger.log(
      loggingStreamId,
      `[getGesundheitsFragenGruppen] - Returning: ${JSON.stringify(gesundheitsFragenGruppen, null, 2)}`
    );

    return gesundheitsFragenGruppen;
  }

  getZusatzFragenSonderbehandlung(person: Person): IZusatzFlagsFuerSonderBehandlung {
    const zusatzFragenSonderbehandlungKey: string = this.zusatzFragenSonderbehandlungKey(person);
    let zusatzFlags: IZusatzFlagsFuerSonderBehandlung = this.getItem(zusatzFragenSonderbehandlungKey);
    if (!zusatzFlags) {
      zusatzFlags = getZusatzFragenSonderbehandlungForPerson(person);
      this.putItem(zusatzFragenSonderbehandlungKey, zusatzFlags);
    }
    return zusatzFlags;
  }

  gesundheitsFragenGruppenKey(person: Person): string {
    return `gesundheitsFragenGruppenKey_${person.id}`;
  }

  fragenKey(person: Person): string {
    return `fragen_${person.id}`;
  }

  zusatzFragenSonderbehandlungKey(person: Person): string {
    return `zusatzfragenSonderBehandlung_${person.id}`;
  }

  getFragenForTarif(tarifschluessel: string): IAntragFragen {
    const fragenKey: string = this.fragenKeyForTarif(tarifschluessel);
    let fragen: IAntragFragen = this.getItem(fragenKey);
    if (!fragen) {
      fragen = getFragenDefsForLvTarif(tarifschluessel);
      this.putItem(fragenKey, fragen);
    }
    return fragen;
  }

  fragenKeyForTarif(tarifschluessel: string): string {
    return `fragenForTarif_${tarifschluessel}`;
  }
}

export const antragContext: AntragContext = new AntragContext();
